const options = {
  5: "bg-pink-700/5",
  10: "bg-pink-700/10",
  25: "bg-pink-700/25",
  50: "bg-pink-700/50",
  75: "bg-pink-700/75",
  90: "bg-pink-700/90",
  100: "bg-pink-700",
};

const from = {
  5: "from-pink-700/5",
  10: "from-pink-700/10",
  25: "from-pink-700/25",
  50: "from-pink-700/50",
  75: "from-pink-700/75",
  90: "from-pink-700/90",
  100: "from-pink-700",
};

export default function getBackgroundPink700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
